function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 0C5.37097 0 0 5.37097 0 12C0 18.629 5.37097 24 12 24C18.629 24 24 18.629 24 12C24 5.37097 18.629 0 12 0ZM12 4.64516C14.3516 4.64516 16.2581 6.55161 16.2581 8.90323C16.2581 11.2548 14.3516 13.1613 12 13.1613C9.64839 13.1613 7.74194 11.2548 7.74194 8.90323C7.74194 6.55161 9.64839 4.64516 12 4.64516ZM12 21.2903C9.15968 21.2903 6.61452 20.0032 4.91129 17.9903C5.82097 16.2774 7.60161 15.0968 9.67742 15.0968C9.79355 15.0968 9.90968 15.1161 10.021 15.15C10.65 15.3532 11.3081 15.4839 12 15.4839C12.6919 15.4839 13.3548 15.3532 13.979 15.15C14.0903 15.1161 14.2065 15.0968 14.3226 15.0968C16.3984 15.0968 18.179 16.2774 19.0887 17.9903C17.3855 20.0032 14.8403 21.2903 12 21.2903Z"
});

var SvgProfile = function SvgProfile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile.79e43fa7.svg";
export { ForwardRef as ReactComponent };